import { render, staticRenderFns } from "./ClientMembers.vue?vue&type=template&id=40039929&scoped=true&"
import script from "./ClientMembers.vue?vue&type=script&lang=js&"
export * from "./ClientMembers.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/components/tabs-accordian/custom-tabs.css?vue&type=style&index=0&id=40039929&scoped=true&lang=css&"
import style1 from "@/assets/css/tables/table-basic.css?vue&type=style&index=1&id=40039929&scoped=true&lang=css&"
import style2 from "./ClientMembers.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40039929",
  null
  
)

export default component.exports